/* Crème de la Crème — landing interactions: nav scroll state, live city clocks, scroll reveal */
(function () {
  'use strict';

  // ---------- Nav: transparent -> frosted on scroll ----------
  function initNav() {
    var nav = document.querySelector('[data-crm-nav]');
    if (!nav) return;
    var onScroll = function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Hero: live LA / Paris / London clocks ----------
  var clockTimer = null;
  function tickClocks() {
    var groups = document.querySelectorAll('[data-crm-clocks]');
    if (!groups.length) return false;
    var now = new Date();
    groups.forEach(function (group) {
      group.querySelectorAll('strong[data-tz]').forEach(function (el) {
        try {
          el.textContent = new Intl.DateTimeFormat('en-GB', {
            hour: '2-digit', minute: '2-digit', timeZone: el.getAttribute('data-tz')
          }).format(now);
        } catch (e) { /* invalid tz — leave fallback */ }
      });
    });
    return true;
  }
  function initClocks() {
    if (clockTimer) clearInterval(clockTimer);
    if (tickClocks()) clockTimer = setInterval(tickClocks, 30000);
  }

  // ---------- Scroll reveal ----------
  var REVEAL_SELECTOR = [
    '.crm-section-head', '.crm-about__grid', '.crm-about__stats',
    '.crm-services__list', '.crm-work__grid', '.crm-media__quotes',
    '.crm-media__logos', '.crm-approach__grid', '.crm-request__grid',
    '.crm-footer__top', '.crm-footer__offices'
  ].join(',');

  var revealObserver = null;
  function initReveal() {
    var els = document.querySelectorAll(REVEAL_SELECTOR);
    if (!els.length) return;

    // Show everything immediately (no hidden state) in the theme editor, when
    // reduced motion is preferred, or where IntersectionObserver is unavailable.
    var instant =
      document.documentElement.classList.contains('shopify-design-mode') ||
      !('IntersectionObserver' in window) ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (instant) {
      els.forEach(function (el) { el.classList.add('crm-reveal', 'in'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            revealObserver.unobserve(e.target);
          }
        });
      }, { threshold: 0.08 });
    }

    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      if (el.classList.contains('crm-reveal')) return;
      el.classList.add('crm-reveal');
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) {
        el.classList.add('in'); // already in view on load — reveal now
      } else {
        revealObserver.observe(el);
        // Safety net: never let a section stay hidden if the observer misses it.
        setTimeout(function () { el.classList.add('in'); }, 3000);
      }
    });
  }

  function init() { initNav(); initClocks(); initReveal(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-init when a section is added/redrawn
  document.addEventListener('shopify:section:load', init);
})();
